// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeFanFollowRequestCountBody = {};

export type typeFanFollowRequestCountOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { requestCount: number };
};

export type typeFanFollowRequestCountOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeFanFollowRequestCountOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeFanFollowRequestCountOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaFanFollowRequestCountBody = {
  type: "object",
  properties: {},
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createFanFollowRequestCount(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaFanFollowRequestCountBody);
  }

  return async function postFanFollowRequestCount(
    payload: typeFanFollowRequestCountBody,
  ): Promise<
    typeFanFollowRequestCountOutput200 | typeFanFollowRequestCountOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postFanFollowRequestCount" failed before calling the network. #49482b126364`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#49482b126364" },
        },
        data: null,
      } as typeFanFollowRequestCountOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/fan-follow/request-count`,
      httpMethod: "POST",
      options,
    })) as
      typeFanFollowRequestCountOutput200 | typeFanFollowRequestCountOutput400;
  };
}
